module.exports = __webpack_public_path__ + "media/images/expert__martina-voss-tecklenburg-88429b0c1e97262ff975a91fb654d25d.png";